import {Component} from '@angular/core';
import {ViewSelectSnapshot} from '@ngxs-labs/select-snapshot';
import {AppState} from '../../state/app/app.state';

@Component({
    selector: 'app-core',
    templateUrl: './core.component.html',
    styleUrls: ['./core.component.less'],
    standalone: false,
})
export class CoreComponent {
    @ViewSelectSnapshot(AppState.layoutSmall) layoutSmall: boolean;
}
